module.exports = __webpack_public_path__ + "img/bg-nav.10288357.png";